var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imp"},[_c('v-card',{staticClass:"imp-card"},[_c('div',{staticClass:"imp-card__head"},[_c('v-icon',{staticClass:"imp-card__icon",attrs:{"small":""}},[_vm._v("mdi-timer-outline")]),_vm._v(" Auto-Import ")],1),_c('AutoImportPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }